export const getCanonicalEntityIds = (item) => {
  if (!item) return [];

  const contact = item.otherParticipantData || item;
  const isChat = Boolean(item.otherParticipantData);
  const ids = new Set();

  const addId = (val, prefix = "") => {
    if (val !== undefined && val !== null) {
      const str = String(val).trim();
      if (str && str.toUpperCase() !== "N/A") {
        if (prefix) {
          ids.add(`${prefix}:${str}`);
        }
        ids.add(str);
      }
    }
  };

  const isUserEntity =
    contact.position === "User" ||
    String(contact.businessType || contact.type || "")
      .toLowerCase()
      .includes("user") ||
    String(contact.businessType || "")
      .toLowerCase()
      .includes("generalpublic");

  const shopId =
    contact.shopid ||
    contact.shopId ||
    contact.serviceid ||
    contact.companyid ||
    (!isUserEntity ? contact.id || contact._id : null);

  const userId =
    contact.userid ||
    contact.userId ||
    (isUserEntity ? contact.id || contact._id : null);

  if (shopId) {
    addId(shopId, "shop");
  }
  if (userId) {
    addId(userId, "user");
  }

  // If item is a chat, also register the unique chat document id prefixed so it never collides
  if (isChat && item._id) {
    addId(item._id, "chat");
  }

  if (ids.size > 0) return [...ids];

  const nameCandidates = [
    contact.displayName,
    contact.shopname,
    contact.fullname,
    contact.name,
    item.displayName,
    item.shopname,
    item.fullname,
    item.name,
  ];
  const validName = nameCandidates.find(
    (n) =>
      n &&
      typeof n === "string" &&
      n.trim() !== "" &&
      n.trim().toUpperCase() !== "N/A",
  );
  const normalizedName = validName ? String(validName).toLowerCase().trim() : "";
  return normalizedName ? [`name:${normalizedName}`] : [];
};

export const isSameEntity = (first, second) => {
  if (!first || !second) return false;
  const firstIds = getCanonicalEntityIds(first);
  const secondIds = new Set(getCanonicalEntityIds(second));
  return firstIds.some((id) => secondIds.has(id));
};

export const getItemProfileTypeKey = (item) => {
  if (!item) return "";
  const contact = item.otherParticipantData;
  const target = contact || item;
  const bt = String(
    target?.businessType ||
      target?.linkBusinessType ||
      target?.otherbusinessType ||
      target?.type ||
      target?.category ||
      item?.otherbusinessType ||
      item?.businessType ||
      target?.position ||
      item?.otherposition ||
      "",
  )
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

  if (bt.includes("retailer") || bt.includes("retail")) return "retailerShop";
  if (bt.includes("whole")) return "wholesellerShop";
  if (bt.includes("manufacturer")) return "manufacturerShop";
  if (bt.includes("rawmaterial")) return "rawmaterialShop";
  if (bt.includes("gem")) return "gemShop";
  if (bt.includes("usedvehicle")) return "usedVehicleShop";
  if (bt.includes("used")) return "usedShop";
  if (bt.includes("homemade")) return "homemadeShop";
  if (bt.includes("transport")) return "transportShop";
  if (bt.includes("farm")) return "farmingShop";
  if (bt.includes("recycle")) return "recycledShop";
  if (bt.includes("food") || bt.includes("restaurant")) return "foodShop";
  if (bt.includes("property")) return "businessPropertyCompany";
  if (bt.includes("job")) return "jobsCompany";
  if (bt.includes("service")) return "services";
  if (bt.includes("marketer")) return "marketerShop";
  if (bt.includes("generalpublic") || bt.includes("user")) return "user";
  return bt;
};
